import request from ".";

// 修改供应商
function updateSupplier(data){
  return request('/product/default/amazon/supplier/updateSupplier', 'post', data)
}

// 新建供应商
function newSupplier(data){
  return request('/product/default/amazon/supplier/newSupplier', 'post', data)
}

// 获取供应商列表
function getList(data){
  return request('/product/default/amazon/supplier/suppliersList', 'post', data)
}

// 删除供应商
function deleteSupplier(data){
  return request('/product/default/amazon/supplier/' + data.id, 'delete', null)
}

export default{
  updateSupplier, newSupplier, getList, deleteSupplier
}
